import React from "react";
import usePageMetadata from "../hooks/usePageMetadata";

const LegalNotice = () => {
  usePageMetadata({
    title: "TOLSOL | Aviso legal",
    description:
      "Accede al aviso legal de TOLSOL y conoce la informaci\u00f3n corporativa y las condiciones de uso de este sitio web.",
  });

  return (
    <main className="bg-[#F2F2F2] pt-32 pb-16 text-[#0A192F]">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-4xl font-bold mb-4">Aviso legal</h1>
        <p className="text-[#0A192F]/70 leading-relaxed">
          Toda la informaci\u00f3n legal de TOLSOL estar\u00e1 disponible pr\u00f3ximamente. Mientras tanto, puedes
          solicitarnos los detalles legales completos contactando con nosotros en{" "}
          <a href="mailto:info@tolsol.es" className="text-[#134b8a] underline">
            info@tolsol.es
          </a>
          .
        </p>
      </div>
    </main>
  );
};

export default LegalNotice;
